import { FormControl, Select, MenuItem, Box } from "@mui/material";
import type { SettlementSummary } from "Infrastructure/Api/Api";
import { SettlementFilter, SettlementSortBy } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Settlements.SettlementControls;

type Props = {
  summary: SettlementSummary;
  filter: SettlementFilter;
  sortBy: SettlementSortBy;
  onFilterChange: (filter: SettlementFilter) => void;
  onSortChange: (sortBy: SettlementSortBy) => void;
};

export const SettlementFilterControls = ({
  summary: { paid, unpaid, overdue, total },
  filter,
  sortBy,
  onFilterChange,
  onSortChange,
}: Props) => {
  const { t } = useResource();

  return (
    <Box gap={2} display="flex">
      <FormControl size="small">
        <Select
          value={filter}
          onChange={(e) => onFilterChange(e.target.value as SettlementFilter)}
          displayEmpty
        >
          <MenuItem value={SettlementFilter.All}>
            {t(COMPONENT_RESOURCES.Filter.All, { total })}
          </MenuItem>
          <MenuItem value={SettlementFilter.Paid}>
            {t(COMPONENT_RESOURCES.Filter.Paid, { paid })}
          </MenuItem>
          <MenuItem value={SettlementFilter.Unpaid}>
            {t(COMPONENT_RESOURCES.Filter.Unpaid, { unpaid })}
          </MenuItem>
          <MenuItem value={SettlementFilter.Overdue}>
            {t(COMPONENT_RESOURCES.Filter.Overdue, { overdue })}
          </MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small">
        <Select
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value as SettlementSortBy)}
        >
          <MenuItem value={SettlementSortBy.DateDesc}>
            {t(COMPONENT_RESOURCES.Sort.DateDesc)}
          </MenuItem>
          <MenuItem value={SettlementSortBy.DateAsc}>
            {t(COMPONENT_RESOURCES.Sort.DateAsc)}
          </MenuItem>
          <MenuItem value={SettlementSortBy.AmountDesc}>
            {t(COMPONENT_RESOURCES.Sort.AmountDesc)}
          </MenuItem>
          <MenuItem value={SettlementSortBy.AmountAsc}>
            {t(COMPONENT_RESOURCES.Sort.AmountAsc)}
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};
